import { Route } from '@angular/router';

import { AnalyticsComponent } from './analytics/analytics.component';
import { CanActivateMain, CanActivateMenu } from './app.permissions';
import { BudgetViewComponent } from './budget/budget-view/budget-view.component';
import { BudgetsComponent } from './budget/budgets/budgets.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ClientComponent } from './client/client.component';
import { clientRoutes } from './client/client.routes';
import { CRMComponent } from './crm/crm.component';
import { crmRoutes } from './crm/crm.routes';
import { InventoryComponent } from './inventory/inventory.component';
import { inventoryRoutes } from './inventory/inventory.routes';
import { LoginComponent } from './login/login.component';
import { AgendaComponent } from './main/agenda/agenda.component';
import { CheckInComponent } from './main/check-in/check-in.component';
import { MainComponent } from './main/main.component';
import { OrderComponent } from './main/order/order.component';
import { OrdersComponent } from './main/orders/orders.component';
import { ManagerComponent } from './manager/manager.component';
import { managerRoutes } from './manager/manager.routes';
import { PaymentsComponent } from './payments/payments.component';
import { RoleComponent } from './role/role.component';
import { SettingsComponent } from './settings/settings.component';
import { SharesComponent } from './shares/shares.component';
import { IframeRejectedComponent } from './utils/iframe-rejected/iframe-rejected.component';
import { VehiclesComponent } from './vehicles/vehicles.component';
import { WorkComponent } from './work/work.component';
import { WorkDialogComponent } from './work/work-dialog/work-dialog.component';
import { WorkPointComponent } from './work-point/work-point.component';
import { workPointRoutes } from './work-point/work-point.routes';
import { ZipComponent } from './zip/zip.component';
import { providerRoutes } from './providers/provider.routes';
import { ProviderComponent } from './providers/provider.component';
import { InventoryActionDetailsComponent } from './inventory/actions/details/inventory-action-details.component';
import { PageNotFoundComponent } from './utils/page-not-found/page-not-found.component';
import { ForbiddenComponent } from './utils/forbidden/forbidden.component';
import { BookingComponent } from './main/booking/booking.component';

export const routes: Route[] = [
  { 
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
  },
  { path: 'login', component: LoginComponent },
  { path: 'booking-addon', redirectTo: 'client/booking' },
  { path: 'client', component: ClientComponent, children: clientRoutes },
  { path: 'forbidden', component: ForbiddenComponent },
  { path: 'iframe-rejected', component: IframeRejectedComponent },
  
  {
    path: 'main',
    component: MainComponent,
    canActivate: [CanActivateMain],
    children: [
      { path: 'analytics', component: AnalyticsComponent, canActivate: [CanActivateMenu] },
      { path: 'booking', component: AgendaComponent, canActivate: [CanActivateMenu] },
      { path: 'budgets', component: BudgetsComponent },
      { path: 'budgets/:id', component: BudgetViewComponent },
      { path: 'calendar', component: CalendarComponent, canActivate: [CanActivateMenu] },
      { path: 'checkin', component: CheckInComponent, canActivate: [CanActivateMenu] },
      { path: 'crm', component: CRMComponent, canActivate: [CanActivateMenu], children: crmRoutes },
      { path: 'folders', loadChildren: () => import('./folder/folder-routing.module').then(m => m.FolderRoutingModule) },
      { path: 'inventory', component: InventoryComponent, canActivate: [CanActivateMenu], children: inventoryRoutes },
      { path: 'inventory-actions/:id', component: InventoryActionDetailsComponent },
      { path: 'invoices', loadChildren: () => import('./invoice/invoice-routing.module').then(m => m.InvoiceRoutingModule) },
      { path: 'orders', component: OrdersComponent, canActivate: [CanActivateMenu] },
      { path: 'orders/:id', component: OrderComponent, canActivate: [CanActivateMenu] },
      { path: 'bookings/:id', component: BookingComponent, canActivate: [CanActivateMenu] },
      { path: 'payments', component: PaymentsComponent, canActivate: [CanActivateMenu] },
      { path: 'roles', component: RoleComponent, canActivate: [CanActivateMenu] },
      { path: 'shares', component: SharesComponent, canActivate: [CanActivateMenu] },
      { path: 'settings', component: SettingsComponent },
      { path: 'vehicles', component: VehiclesComponent, canActivate: [CanActivateMenu] },
      { path: 'work', component: WorkComponent, canActivate: [CanActivateMenu] },
      { path: 'work/:id', component: WorkDialogComponent, canActivate: [CanActivateMenu] },
      { path: '**', redirectTo: 'not-found' },
    ],
  },
  { path: 'manager', component: ManagerComponent, children: managerRoutes },
  { path: 'not-found', component: PageNotFoundComponent },
  { path: 'provider', component: ProviderComponent, children: providerRoutes },
  { path: 'workpoint', component: WorkPointComponent, children: workPointRoutes },
  { path: 'zip/:model/:id', component: ZipComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'not-found'},
];
